const users = {
    name: 'Users/UsersPage',
    path: '/users',
    icon: 'mdi-account-group',
    label: 'Users'
};

const dashboard = {
    name: 'Dashboard/DashboardPage',
    path: '/',
    icon: 'mdi-view-dashboard',
    label: 'Dashboard'
};

const profile = {
    name: 'Dashboard/UserProfilePage',
    path: '/profile',
    icon: 'mdi-account',
    label: 'Profile'
};

const programs = {
    name: 'Dashboard/ProgramsPage',
    path: '/programs',
    icon: 'mdi-clipboard-list',
    label: 'Programs'
};

const programsComparisons = {
    name: 'Dashboard/ProgramsComparisonsPage',
    path: '/programs-comparisons',
    icon: 'mdi-file-compare',
    label: 'Programs Comparisons'
};

const horizon = {
    name: 'Horizon',
    path: '/horizon',
    icon: 'mdi-sun-angle',
    label: 'Horizon',
    private: true,
    privateLabel: 'SA'
};

const pulse = {
    name: 'Pulse',
    path: '/pulse',
    icon: 'mdi-pulse',
    label: 'Pulse',
    private: true,
    privateLabel: 'SA'
};

const telescope = {
    name: 'Telescope',
    path: '/telescope',
    icon: 'mdi-telescope',
    label: 'Telescope',
    private: true,
    privateLabel: 'SA'
};

const productConfigurations = {
    name: 'ProductConfigurations/ProductConfigurationsPage',
    path: '/product-configurations',
    icon: 'mdi-cog-outline',
    label: 'Product Configuration'
};

const ruleEngine = {
    name: 'RuleEngine/RuleEnginePage',
    path: '/rule-engine',
    icon: 'mdi-gavel',
    label: 'Rule Engine'
};

export const superAdmin = _ => {
    return [
        dashboard,
        users,
        productConfigurations,
        ruleEngine,
        programs,
        programsComparisons
    ];
};

export const admin = _ => {
    return [
        dashboard,
        users,
        productConfigurations,
        ruleEngine,
        programs,
        programsComparisons
    ];
};

export const user = _ => {
    return [
        dashboard,
    ];
};

export const bottomNavRoutes = _ => {
    return [
        profile,
        horizon,
        pulse,
        telescope,
    ];
};
